import React from 'react'
import { createRoot } from 'react-dom/client'

import TimelineApp from './app'

window.initTimelineApp = (container, params) => {
  const root = createRoot(container);

  root.render(
    <TimelineApp
      {...params}
    />,
  );
};
